<style>
    .active {
        @apply bg-blue-100 text-blue-800;
    }
    a:not(.active):hover {
        @apply bg-gray-300;
    }
    a:not(.active) {
        @apply text-blue-400;
    }

    .mobile-navigation {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        background: white;
        border-top: 1px solid rgba(26, 32, 44, 0.12);
        padding-bottom: env(safe-area-inset-bottom);
    }

    .page-content {
        margin-bottom: calc(4rem + env(safe-area-inset-bottom));
    }

    summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 3.5rem;
        padding: 0.75rem 1rem;
        cursor: pointer;
        list-style: none;
    }

    summary::-webkit-details-marker {
        display: none;
    }

    .menu-icon {
        width: 1rem;
        height: 0.875rem;
        margin-right: 0.5rem;
        flex-shrink: 0;
        border-top: 2px solid currentColor;
        border-bottom: 2px solid currentColor;
        background: linear-gradient(currentColor, currentColor) center / 100%
            2px no-repeat;
    }

    .mobile-navigation nav {
        max-height: 65dvh;
        overflow-y: auto;
        padding: 0 0.5rem 0.5rem;
    }

    .mobile-navigation a {
        display: flex;
        align-items: center;
        min-height: 3rem;
        padding: 0.75rem;
        border-radius: 0.25rem;
        color: #4a5568;
    }

    .mobile-navigation a.active {
        color: #2c5282;
    }

    a:focus-visible,
    summary:focus-visible {
        outline: 2px solid #3182ce;
        outline-offset: -2px;
    }
</style>

<script>
    import { route, url } from '@sveltech/routify';

    const links = [
        ['/productos/existencias/', 'Inventario'],
        ['/productos/', 'Productos'],
        ['/productos/inventario/', 'Actualizar Inventario'],
        ['/productos/archivo/', 'Actualizar Precios'],
        ['/compras/', 'Compras'],
        ['/ventas/', 'Ventas'],
        ['/notas/', 'Capturar Nota de Venta'],
    ];

    const normalizarRuta = path => path.replace(/\/+$/, '') || '/';
    let menuAbierto = false;

    $: rutaActiva = normalizarRuta(
        $route.shortPath || window.location.pathname
    );
    $: rutaActiva, (menuAbierto = false);
    $: nombreActivo = (links.find(
        ([path]) => normalizarRuta(path) === rutaActiva
    ) || ['', 'Swiper'])[1];
</script>

<div class="page-content">
    <slot />
</div>

{#if rutaActiva !== '/login'}
    <nav
        aria-label="Navegación principal"
        class="hidden lg:block fixed bottom-0 left-0 right-0 py-4 pl-2
        overflow-x-auto bg-gray-100 border-t whitespace-no-wrap"
    >
        {#each links as [path, name]}
            <a
                href="{$url(path)}"
                class:active="{rutaActiva === normalizarRuta(path)}"
                aria-current="{rutaActiva === normalizarRuta(path) ? 'page' : undefined}"
                class="px-3 py-2 mx-2 rounded"
            >
                {name}
            </a>
        {/each}
    </nav>
    <details class="mobile-navigation lg:hidden" bind:open="{menuAbierto}">
        <summary>
            <span class="min-w-0">{nombreActivo}</span>
            <span class="flex items-center flex-shrink-0 ml-3">
                <span class="menu-icon" aria-hidden="true"></span>
                Menú
            </span>
        </summary>
        <nav aria-label="Navegación principal">
            {#each links as [path, name]}
                <a
                    href="{$url(path)}"
                    class:active="{rutaActiva === normalizarRuta(path)}"
                    aria-current="{rutaActiva === normalizarRuta(path) ? 'page' : undefined}"
                    on:click="{() => (menuAbierto = false)}"
                >
                    {name}
                </a>
            {/each}
        </nav>
    </details>
{/if}
